import { Injectable } from '@angular/core';
import {
  combineLatest,
  MonoTypeOperatorFunction,
  Observable,
  ObservableInput,
  ReplaySubject,
  skipWhile,
  startWith,
  Subject,
} from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  userChanged$: Subject<boolean | null> = new Subject<boolean | null>();
  companyChanged$: Subject<boolean | null> = new Subject<boolean | null>();

  cachingOnAuthContextChanged<T = unknown>(): MonoTypeOperatorFunction<T> {
    return this.baseCaching(() => this.getAuthContextChanged$());
  }

  cachingOnUserChanged<T = unknown>(): MonoTypeOperatorFunction<T> {
    return this.baseCaching(() => this.userChanged$);
  }

  cachingOnCompanyChanged<T = unknown>(): MonoTypeOperatorFunction<T> {
    return this.baseCaching(() => this.companyChanged$);
  }

  getAuthContextChanged$(): Observable<readonly [boolean | null, boolean | null]> {
    return combineLatest([this.companyChanged$.pipe(startWith(null)), this.userChanged$.pipe(startWith(null))]).pipe(
      skipWhile(([company, user]) => company == null && user == null),
    );
  }

  private baseCaching<T = unknown>(resetOnComplete: () => ObservableInput<unknown>): MonoTypeOperatorFunction<T> {
    return share<T>({
      connector: () => new ReplaySubject(1),
      resetOnComplete,
    });
  }
}
